// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__383PH","bigColWidth":"Table_bigColWidth__OlE86","biggerColWidth":"Table_biggerColWidth__1nes7","row":"Table_row__1dHKu","col":"Table_col__3nkwe"};